import { render, staticRenderFns } from "./SponsorListContainer.vue?vue&type=template&id=7f8e1582&scoped=true"
import script from "./SponsorListContainer.vue?vue&type=script&lang=js"
export * from "./SponsorListContainer.vue?vue&type=script&lang=js"
import style0 from "./SponsorListContainer.vue?vue&type=style&index=0&id=7f8e1582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e1582",
  null
  
)

export default component.exports